import { render, staticRenderFns } from "./BhBackgroundPhq.vue?vue&type=template&id=08371d17"
import script from "./BhBackgroundPhq.vue?vue&type=script&lang=js"
export * from "./BhBackgroundPhq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports